import {getFile} from '~/api'

async function get(request, fileName) {
    return await getFile('/api/downloadStatementOfAccount', request, fileName)
}

export {get}
